import React, { useState, useEffect, useCallback } from 'react'
import { Pagination, Row, Col} from 'antd'
import moment from 'moment'
import axios from 'axios'

import PageHeader from '../Layout/PageHeader'
import OrderEventList from './OrderEventList'

import { PERMISSIONS } from "../../constants/roles";
import { usePermissions } from "../App/PermissionContext"; 

const today = moment()
const oneWeekAgo = moment().subtract(7, 'days')



const OrderEvent = () => {
  const { permissions } = usePermissions();
  
  const [orders, setOrders] = useState([])
  const [filters, setFilters] = useState({ isRemittance: null, completeDelivered: null, startDate: oneWeekAgo, endDate: today })
  const [pagination, setPagination] = useState({ currentPage: 1, limit: 10 })
  const [isLoading, setIsLoading] = useState(false)
  const [selectedRows, setSelectedRows] = useState([])

  const fetchOrderEvents = useCallback(async () => {
    setIsLoading(true)

    const params = {
      ...(filters.channel) && { channel: filters.channel },
      ...(filters.search && { searchField: filters.searchField, search: filters.search }),
      ...(filters.serviceProvider && { serviceProvider: filters.serviceProvider }),
      ...(filters.internalStatus && { internalStatus: filters.internalStatus }),
      limit: pagination.limit,
      page: pagination.currentPage
    }

    const res = await axios.get("/api/order-events", { params })
    setOrders(res.data.data)
    setPagination(res.data.pagination)
    setIsLoading(false)
  }, [filters])

  useEffect(() => {
    fetchOrderEvents()
  }, [ fetchOrderEvents])
  
  return (
    <div>
      <PageHeader 
        title="Order Event"
        childRoutes={[{ path: "/order-event", breadcrumbName: "Order Event" }]}
      />

      <Row
          className="mt-2 mb-2"
          justify="space-between"
          align="middle"
        >

        <Col>
          <Pagination 
            total={pagination?.totalSize} 
            pageSize={pagination?.limit}
            onChange={((currentPage, limit) => { setPagination({ ...pagination, limit, currentPage }) })}
            current={pagination.currentPage} 
          />
        </Col>
      </Row>

      <OrderEventList 
        orders={orders} 
        onSelectRows={selectedRowKeys => setSelectedRows(selectedRowKeys)}
        selectedRows={selectedRows}
        loading={isLoading}
        showButtons={{ download: true, markCancelledByUser: true, invoice: true }}
        onMarkCancelled={() => fetchOrderEvents()}
        
      />

      <Row justify="end">
        <Col>
          <Pagination 
            total={pagination?.totalSize} 
            pageSize={pagination?.limit}
            onChange={((currentPage, limit) => { setPagination({ ...pagination, limit, currentPage }) })}
            current={pagination.currentPage} 
          />
        </Col>
      </Row>
    </div>
  )
}

export default OrderEvent